import AJV from "ajv";
const ajv = new AJV();
const CLASSES = {
    Function
};
ajv.addKeyword({
    keyword: "instanceof",
    schemaType: "string",
    validate(schema, data) {
        // @ts-expect-error Tech debt (fix me CX-16279) - error enabled as part of CX-21272
        return data instanceof CLASSES[schema];
    }
});
export const inputValidator = (schema, obj) => {
    const validator = ajv.compile(schema);
    let errorMessage = "";
    if (validator(obj)) {
        return {
            success: true,
            errors: []
        };
    }
    const { errors } = validator;
    if (errors) {
        for (const error of errors) {
            switch (error.keyword) {
                case "required":
                    errorMessage += `${error.message}`;
                    break;
                case "type":
                    errorMessage += ` Property - ${error.instancePath} ${error.message} ||`;
                    break;
                default:
                    errorMessage += `${error.message}`;
                    break;
            }
        }
    }
    return {
        success: false,
        errorMessage
    };
};
